"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
export default class ProxyTransform {
  static proxyTransform(data) {
    return __async(this, null, function* () {
      let host = null;
      if (["http", "https", "socks5"].includes(data.proxy_protocol)) {
        host = {
          "model": "proxy.v2ray",
          "log": {
            "model": "proxy.v2ray.log",
            "access": "",
            "error": "",
            "loglevel": "error"
          },
          "inbounds": [
            {
              "port": 0,
              "listen": "127.0.0.1",
              "protocol": "http",
              "settings": {
                "timeout": 360
              }
            }
          ],
          "outbounds": [
            __spreadValues({
              "tag": "proxy",
              "protocol": (() => {
                if (data.proxy_protocol === "socks5") {
                  return "socks";
                }
                if (data.proxy_protocol === "https") {
                  return "http";
                }
                return data.proxy_protocol;
              })(),
              "settings": {
                "servers": [
                  __spreadValues({
                    "address": data.proxy_ip,
                    "port": parseInt(data.proxy_port)
                  }, (() => {
                    if (data.proxy_password && data.proxy_account) {
                      return {
                        "users": [
                          {
                            "user": data.proxy_account,
                            "pass": data.proxy_password
                          }
                        ]
                      };
                    }
                    return {};
                  })())
                ]
              }
            }, (() => {
              if (data.proxy_protocol === "https") {
                return {
                  "streamSettings": {
                    "network": "tcp",
                    "security": "tls",
                    "tcpSettings": {
                      "header": {
                        "type": "none"
                      }
                    },
                    "tlsSettings": {
                      "allowInsecure": true
                    }
                  }
                };
              }
            })()),
            {
              tag: "direct",
              protocol: "freedom"
            },
            {
              tag: "blackhole",
              protocol: "blackhole"
            }
          ]
        };
      }
      if (data.proxy_protocol === "shadowsocks") {
        host = {
          "model": "proxy.v2ray",
          "log": {
            "model": "proxy.v2ray.log",
            "access": "",
            "error": "",
            "loglevel": "error"
          },
          "inbounds": [
            {
              "port": 0,
              "listen": "127.0.0.1",
              "protocol": "http"
            }
          ],
          "outbounds": [
            {
              "tag": "proxy",
              "protocol": data.proxy_protocol,
              "settings": {
                "servers": [
                  {
                    "address": data.proxy_ip,
                    "port": parseInt(data.proxy_port),
                    "method": data.proxy_method,
                    "password": data.proxy_password
                  }
                ]
              }
            },
            {
              tag: "direct",
              protocol: "freedom"
            },
            {
              tag: "blackhole",
              protocol: "blackhole"
            }
          ],
          "dns": {
            "model": "proxy.v2ray.servers",
            "servers": []
          }
        };
      }
      if (data.proxy_protocol === "ssh") {
        host = {
          "model": "proxy.ssh",
          "local": "",
          "address": `${data.proxy_ip}:${data.proxy_port}`,
          "username": data.proxy_account,
          "password": data.proxy_password
        };
      }
      return host;
    });
  }
}
